import { useTranslation } from 'react-i18next'

import Text from '../../../Text'
import { BirdviewChartCatalogRow } from '../BirdviewChartCatalogRow'

import * as styles from './BirdviewChartCatalogGroup.module.css'

function BirdviewChartCatalogGroup({ group, onToggle }) {
  const { t } = useTranslation()

  return (
    <div className={styles.group}>
      <Text isSecondary className={styles.title}>
        {t(group.labelKey)}
      </Text>
      {group.rows.map(row => (
        <BirdviewChartCatalogRow key={row.id} row={row} onToggle={onToggle} />
      ))}
    </div>
  )
}

export default BirdviewChartCatalogGroup
